import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpError } from './http-error';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  private readonly toastService = inject(ToastService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        const error = HttpError.fromDto(response);
        if (error.isApiError()) {
          this.showToast(error);
        }
        return throwError(response);
      }),
    );
  }

  private showToast(error: HttpError): void {
    if (error.status === 401 || error.status === 403) {
      return;
    }
    if (error.status === 400) {
      this.toastService.error('error.400');
    } else if (error.status === 404) {
      this.toastService.error('error.404');
    } else {
      this.toastService.error('error.general');
    }
  }
}
